export type BillingsOrderCargoTaxiRecalculateRequestBillingNode = {
  id: string;
  nodeId: string;
  checkoutEventId?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinated: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export enum BillingsOrderCargoTaxiRecalculateRequestBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsOrderCargoTaxiRecalculateRequestBillingContributionBaseAmount =
  {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.BASE_AMOUNT;
    comment?: string;
    distance: number;
    rate: number;
  };

export type BillingsOrderCargoTaxiRecalculateRequestBillingContributionChargeHaltings =
  {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.CHARGE_HALTING;
    comment?: string;
    distance: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateRequestBillingContributionContractCorrectionPercentage =
  {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountOptimization =
  {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountBeingLate =
  {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.DISCOUNT_BEING_LATE;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountOther =
  {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.DISCOUNT_OTHER;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateRequestBillingContribution =
  | BillingsOrderCargoTaxiRecalculateRequestBillingContributionBaseAmount
  | BillingsOrderCargoTaxiRecalculateRequestBillingContributionChargeHaltings
  | BillingsOrderCargoTaxiRecalculateRequestBillingContributionContractCorrectionPercentage
  | BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountOptimization
  | BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountBeingLate
  | BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountIncompatibleCar
  | BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountOther;

export type BillingsOrderCargoTaxiRecalculateRequestBody = {
  billingNodes: BillingsOrderCargoTaxiRecalculateRequestBillingNode[];
  billingContributions: BillingsOrderCargoTaxiRecalculateRequestBillingContribution[];
};

type BillingsOrderCargoTaxiRecalculateRequest = {
  orderUuid: string;
  billingNodes: BillingsOrderCargoTaxiRecalculateRequestBillingNode[];
  billingContributions: BillingsOrderCargoTaxiRecalculateRequestBillingContribution[];
};

export default BillingsOrderCargoTaxiRecalculateRequest;
